import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';

export default class MediaPlayer extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
  }

  render() {
    const aspectRatio = 100 / (16 / 9);
    const style = { paddingTop: aspectRatio + '%' };

    return (
      <div className="u-relative u-rounded u-overflow-hidden" style={style}>
        <ReactPlayer
          width="100%"
          height="100%"
          className="u-absolute u-top-0 u-left-0"
          {...this.props}
        />
      </div>
    );
  }
}
